module.exports = ":host {\n  overflow: hidden auto;\n  transition-property: flex;\n  transition-duration: 0s;\n  transition-timing-function: linear; }\n"